import type { DeepPartial } from '@luna/utils-ts';

import type { Orders } from '../../types/Orders';

export const ordersHUFeatureConfig: DeepPartial<Orders> = {
    showPortfolioDropdown: true,
};
